import { useAuth } from './auth/AuthContext';
import './App.css';
import Dashboard from './components/Dashboard';
import Profile from './Profile';
import LoginButton from './Login'
import { useSelector, } from 'react-redux'
import { BaseClass } from './api/BaseClass';


function App() {
  const { isAuthenticated, isLoading, getAccessToken } = useAuth();
  BaseClass.configure(getAccessToken);

  const globalInfo = useSelector((state) => state.globalInfo)

  // eslint-disable-next-line
  Object.defineProperty(String.prototype, "getFormattedPhoneNum", {
    value: function getFormattedPhoneNum() {
      let phoneNumber = this.trim();
      
      // Remove +1 from the beginning if it exists
      if (phoneNumber.startsWith("+1")) {
        phoneNumber = phoneNumber.slice(2).trim();
      }
  
      let output = "(";
      phoneNumber.replace(/^\D*(\d{0,3})\D*(\d{0,3})\D*(\d{0,4})/, function (match, g1, g2, g3) {
        if (g1.length) {
          output += g1;
          if (g1.length === 3) {
            output += ")";
            if (g2.length) {
              output += " " + g2;
              if (g2.length === 3) {
                output += "-";
                if (g3.length) {
                  output += g3;
                }
              }
            }
          }
        }
      });
  
      return output;
    },
    writable: true,
    configurable: true,
  });
  
  
  if (isLoading) {
    return null;
  }

  if (!isAuthenticated) {
    return <LoginButton />;
  }


  return (
    <div className="portal-app">
      <Profile />
      {globalInfo.currentCompanyId && <Dashboard />}
    </div>
  );
}

export default App;
